import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

export const orgDashboardRouteGroup = new AppRouteGroup({
  path: '/admin/:orgId',
  params: ['orgId'],
});

export const orgDashboardHomeRoute = orgDashboardRouteGroup.route({
  path: '',
});

export const orgDashboardPostAListingRoute = orgDashboardRouteGroup.route({
  path: 'post-a-listing',
});

export const orgDashboardCheckoutBillingAddressRoute =
  orgDashboardRouteGroup.route({
    path: 'checkout/billing-address',
    searchParams: ['pack', 'invoiceId'],
  });

export const orgDashboardInvoiceRoute = orgDashboardRouteGroup.route({
  path: 'invoices/:invoiceId',
  params: ['invoiceId'],
});

export const orgDashboardEditJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/edit',
  params: ['jobId'],
});

export const orgDashboardInternshipJobRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/edit',
  params: ['internshipId'],
});
